import { render, staticRenderFns } from "./open-in-browser.vue?vue&type=template&id=3a3b0152&scoped=true&"
import script from "./open-in-browser.vue?vue&type=script&lang=js&"
export * from "./open-in-browser.vue?vue&type=script&lang=js&"
import style0 from "./open-in-browser.vue?vue&type=style&index=0&id=3a3b0152&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3b0152",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/sit-app-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a3b0152')) {
      api.createRecord('3a3b0152', component.options)
    } else {
      api.reload('3a3b0152', component.options)
    }
    module.hot.accept("./open-in-browser.vue?vue&type=template&id=3a3b0152&scoped=true&", function () {
      api.rerender('3a3b0152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/open-in-browser.vue"
export default component.exports